const partners = [
  {
    id: 1,
    affiliationCode: "LWQtRTjWvSNXZ8hzvp4x",
    name: "BIZPIK"
  },
  {
    id: 2,
    affiliationCode: null,
    name: "EDUZZ"
  },
  {
    id: 3,
    affiliationCode: null,
    name: "ALPOP"
  },
  {
    id: 5,
    affiliationCode: null,
    name: "HERING"
  },
  {
    id: 6,
    affiliationCode: "AixGySbAkGxBvTGBDefV",
    name: "VESTI"
  },
  {
    id: 7,
    affiliationCode: null,
    name: "INCHURCH"
  },
  {
    id: 8,
    affiliationCode: null,
    name: "BLUEFLEET"
  }
];

export default partners;
